import { Fragment } from 'react';
import { Content, asText } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { faThumbsUp, faThumbsDown } from '@fortawesome/pro-regular-svg-icons';

import { RichText } from '@preventx/prismic-services';
import { Box, Divider, Heading, Icon } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

export type MythsVsFactsProps = SliceComponentProps<Content.MythsVsFactsSlice>;

const MythsVsFacts = ({ slice }: MythsVsFactsProps) => {
  const { content, title, caption, myth_label, fact_label } = slice.primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box component="section" className="well" addFlow>
      <Heading component="h3">{asText(title)}</Heading>

      <RichText content={caption} variant="default" websiteUrl={WebsiteUrl} />

      {content.map(({ myth, fact }, index) => (
        <Fragment key={`myth-vs-facts-${index + 1}`}>
          <Divider />
          <Box component="div" addSwitcher>
            <Box component="div">
              <Box component="div" addCluster>
                <Box
                  component="span"
                  colour="negative"
                  className="featured-icon"
                >
                  <Icon icon={faThumbsDown} addIcon />
                </Box>
                <Heading component="h4">{asText(myth_label)}</Heading>
              </Box>
              <Box component="div" margin={{ mt: 'mt-3' }}>
                <RichText
                  content={myth}
                  variant="default"
                  websiteUrl={WebsiteUrl}
                />
              </Box>
            </Box>

            <Box component="div" key={`myth-vs-facts-${index + 1}`}>
              <Box component="div" addCluster>
                <Box
                  component="span"
                  colour="positive"
                  className="featured-icon"
                >
                  <Icon icon={faThumbsUp} addIcon />
                </Box>
                <Heading component="h4">{asText(fact_label)}</Heading>
              </Box>
              <Box component="div" margin={{ mt: 'mt-3' }}>
                <RichText
                  content={fact}
                  variant="default"
                  websiteUrl={WebsiteUrl}
                />
              </Box>
            </Box>
          </Box>
        </Fragment>
      ))}
    </Box>
  );
};

export default MythsVsFacts;
